import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Pages that are allowed to have dark mode
const DARK_MODE_ALLOWED_PAGES = [
    '/new-client-dashboard',
    '/new-my-team',
    '/new-client-ordered-report'
];

/**
 * Global dark mode manager that enforces page restrictions
 * This runs on every route change to ensure proper theme management
 */
export const GlobalDarkModeManager = () => {
    const location = useLocation();

    useEffect(() => {
        const root = document.documentElement;
        const isAllowedPage = DARK_MODE_ALLOWED_PAGES.includes(location.pathname);

        if (!isAllowedPage) {
            // Force light mode on non-dashboard pages
            root.style.colorScheme = 'light';
            root.dataset.bpohDashboardTheme = 'light';
        } else {
            // For allowed pages, restore saved preference or use system preference
            try {
                const saved = localStorage.getItem('bpoh-new-dashboard-theme');
                if (saved === 'dark') {
                    root.style.colorScheme = 'dark';
                    root.dataset.bpohDashboardTheme = 'dark';
                } else if (saved === 'light') {
                    root.style.colorScheme = 'light';
                    root.dataset.bpohDashboardTheme = 'light';
                } else {
                    // Use system preference if no saved preference
                    const prefersDark = typeof window !== 'undefined' &&
                        window.matchMedia &&
                        window.matchMedia('(prefers-color-scheme: dark)').matches;

                    root.style.colorScheme = prefersDark ? 'dark' : 'light';
                    root.dataset.bpohDashboardTheme = prefersDark ? 'dark' : 'light';
                }
            } catch (_) {
                // Fallback to light mode
                root.style.colorScheme = 'light';
                root.dataset.bpohDashboardTheme = 'light';
            }
        }
    }, [location.pathname]);

    return null; // This component doesn't render anything
};